import React from 'react';
import LocationTemplate from './LocationTemplate';

const WinfallPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Winfall"
      stateName="North Carolina"
      countyName="Perquimans"
      zipCodes={["27985"]}
      latitude={36.2229}
      longitude={-76.4627}
      population={594}
      historicalFact="Originally called Hertford Mills, renamed Winfall in 1889 after a lumber mill accident."
      nearbyTowns={[
        "Hertford, NC",
        "Elizabeth City, NC",
        "Edenton, NC",
        "Chowan, NC",
        "Camden, NC",
        "Belvidere, NC",
        "Hobbsville, NC",
        "Great Bridge, VA"
      ]}
    />
  );
};

export default WinfallPage;